interface SlugifyOptions {
    prefixIfDigit?: string
    fallback?: string
}

export function slugifyString(value: unknown, opts: SlugifyOptions = {}): string {
    const { prefixIfDigit = '_', fallback = '' } = opts
    let str = value == null ? '' : String(value)
    str = str
        .trim()
        .normalize('NFKD')
        .replace(/\p{Diacritic}/gu, '')
    str = str.replace(/[^a-zA-Z0-9]+/g, '_')
    str = str.replace(/_+/g, '_').replace(/^_+|_+$/g, '')
    if (/^[0-9]/.test(str)) {
        str = `${prefixIfDigit}${str}`
    }
    if (str === '') {
        return fallback
    }
    return str.toLowerCase()
}
